import React from 'react';

import { EmptyState } from '@ergeon/core-components';
import { DevicePhoneMobileIcon } from '@ergeon/icons/hero/outline';

export const MobileNotSupportedEmptyState = () => (
  <div className="flex flex-col justify-center items-center p-12 w-full h-full">
    <EmptyState
      description="This application is optimized for desktop and tablet devices. Please use a larger screen for the best experience."
      icon={<DevicePhoneMobileIcon />}
      title="Mobile Not Supported" />
  </div>
);
